import { decodeToken } from "react-jwt"
import api from "./api"

export const getExtract = async () => {
  const response = await api.get("/extract")
  return response.data
}

export const getPlan = async () => {
  const response = await api.get("/plan")
  return response.data
}

export const getPlanConfig = async () => {
  const response = await api.get("/module")
  return decodeToken(response.data)
}

export const getVoucherByCode = async (cCode) => {
  const response = await api.get(`/voucher/${cCode}/validate`)
  return response.data
}

export const getPostalCodeAddress = async (cValue) => {
  const cZipCode = cValue.replace(/\D/g, "")
  const response = await api.get(`https://cep.acredite.se/cep/${cZipCode}/json`)
  return response
}

export const createSubscription = async (body) => {
  const response = await api.post("customer/signup", body)
  return response.data
}

export const changeSubscription = async (body) => {
  const response = await api.put("customer/subscription-change", body)
  return response.data
}
